import React, { useState, useEffect } from 'react';

import { useForm } from 'react-hook-form';

import Select from 'react-select';

import quantity from '../resources/consecrationQuantity.json';
import resource from '../resources/resource.json';

import { getCartState } from '@msdyn365-commerce/global-state';
import { SimpleProduct, AsyncResult } from '@msdyn365-commerce/retail-proxy';

import { deleteBTGPCartLineAsync, getAllBTGPCartLineAsync } from '../../../actions/DataActionExtension.g';

import { IField, IdState } from '../frontdesk-product-details-form.data';
import { IFrontdeskProductDetailsFormConfig } from '../frontdesk-product-details-form.props.autogenerated';

interface IEcommFormProps {
    formScheme: IField[];
    selectedProduct: AsyncResult<SimpleProduct>;
    subProduct: SimpleProduct;
    rowsData: IdState[];
    addRow(noOfRows: Number): void;
    deleteRow(idx: number): void;
    callbackName?: any;
    callbackCategory?: any;
    callbackDedicatedBy?: any;
    callbackSubProductQuantity?: any;
    callbackNamesEntered?: any;
    formItems: [];
    config: IFrontdeskProductDetailsFormConfig;
    localeCode: string;
    actionContext: any;
    isMobile: boolean;
    isEditMode: boolean;
    allowMultipleRegistrations: boolean;
}

const ThreeCategoryNamesConsecrationForm1: React.FC<IEcommFormProps> = ({
    formScheme,
    selectedProduct,
    subProduct,
    rowsData,
    addRow,
    deleteRow,
    callbackName,
    callbackCategory,
    callbackDedicatedBy,
    callbackSubProductQuantity,
    callbackNamesEntered,
    formItems,
    config,
    localeCode,
    actionContext,
    isMobile,
    isEditMode,
    allowMultipleRegistrations
}) => {
    const [radioValue, setRadioValue] = useState([resource.categoryFamilyLabel[localeCode as 'en' | 'zh']]);
    const [ceremonyName, setCeremonyName] = useState(['']);
    const [dedicatedBy, setDedicatedBy] = useState(['']);
    const [subProductQuantity, setSubProductQuantity] = useState([0]);

    const formLabels = resource.threeCategoryNamesConsecrationForm[localeCode as 'en' | 'zh'];

    const noOfNames = formScheme.find(form => form.field_type === 'textBox')!.field_number!;
    const companyNames = formScheme.find(form => form.field_type === 'textBox')!.field_number2!;
    const deceasedNames = formScheme.find(form => form.field_type === 'textBox')!.field_number3!;

    const onSubmit = (data: any) => {
        // display form data on success
        // alert('SUCCESS!! :-)\n\n' + JSON.stringify(data, null, 4));
    };

    // Functions to build form returned by useForm() hook.
    const { handleSubmit, reset } = useForm();

    const _onChangeRadioValue = (event: any, index: number) => {
        _setRadioValueArray(event.target.value, index);

        const ceremonyNameArray = ceremonyName.slice();
        let existingCeremonyName = ceremonyNameArray[`${index}`];
        const existingNameArray = existingCeremonyName.split(';');

        const dedicatedNameArray = dedicatedBy.slice();
        dedicatedNameArray[`${index}`] = '';

        if (event.target.value === resource.categoryFamilyLabel[localeCode as 'en' | 'zh']) {
            if (existingNameArray.length < noOfNames) {
                existingCeremonyName += ';'.repeat(noOfNames - existingNameArray.length - 1);
            } else {
                // More than
                while (existingNameArray.length > noOfNames) {
                    existingNameArray.pop();
                }
                existingCeremonyName = existingNameArray.join(';');
            }
        } else if (event.target.value === resource.categoryCompanyLabel[localeCode as 'en' | 'zh']) {
            if (existingNameArray.length < companyNames) {
                existingCeremonyName += ';'.repeat(companyNames - existingNameArray.length - 1);
            } else {
                // More than
                while (existingNameArray.length > companyNames) {
                    existingNameArray.pop();
                }
                existingCeremonyName = existingNameArray.join(';');
            }
        } else {
            if (existingNameArray.length < deceasedNames) {
                existingCeremonyName += ';'.repeat(deceasedNames - existingNameArray.length - 1);
            } else {
                // More than
                while (existingNameArray.length > deceasedNames) {
                    existingNameArray.pop();
                }
                existingCeremonyName = existingNameArray.join(';');
            }
        }

        ceremonyNameArray[`${index}`] = existingCeremonyName;

        setCeremonyName(ceremonyNameArray);
        setDedicatedBy(dedicatedNameArray);

        callbackName(ceremonyNameArray);
        callbackDedicatedBy(dedicatedNameArray);
    };

    const _setSubProductQuantity = (event: any, index: number) => {
        const valueArray = subProductQuantity.slice();

        while (typeof valueArray[`${index}`] === 'undefined') {
            valueArray.push(0);
        }

        valueArray[`${index}`] = +event.value;

        setSubProductQuantity(valueArray);

        callbackSubProductQuantity(valueArray);
    };

    const _setRadioValueArray = (value: string, index: number) => {
        const radioValueArray = radioValue.slice();

        while (typeof radioValueArray[`${index}`] === 'undefined') {
            radioValueArray.push(resource.categoryFamilyLabel[localeCode as 'en' | 'zh']);
        }

        radioValueArray[`${index}`] = value;

        setRadioValue(radioValueArray);

        callbackCategory(radioValueArray);
    };

    const _displayName = (value: string, nameIndex: number): string => {
        if (value) {
            const names = value.split(';');

            return names[`${nameIndex}`] ? names[`${nameIndex}`] : '';
        }

        return '';
    };

    const _setNameMultipleInputValue = (event: any, index: number, nameIndex: number, noOfNames: number) => {
        const maxLength = config.charactersLimitForNames ? config.charactersLimitForNames : 31;

        let inputName = event.target.value.substring(0, maxLength - 1);
        let inputMultipleName = ceremonyName[`${index}`];

        if (!inputMultipleName.includes(';')) {
            inputMultipleName += ';'.repeat(noOfNames - 1);
        }

        const inputMutlipleNameSplit = inputMultipleName.split(';');

        inputMutlipleNameSplit[`${nameIndex}`] = inputName;
        inputName = inputMutlipleNameSplit.join(';');

        _setCeremonyNameArray(inputName, index);
    };

    const _setCeremonyNameArray = (name: string, index: number) => {
        const ceremonyNameArray = ceremonyName.slice();

        while (typeof ceremonyNameArray[`${index}`] === 'undefined') {
            ceremonyNameArray.push('');
        }

        ceremonyNameArray[`${index}`] = name;

        ceremonyNameArray[`${index}`].trim();

        setCeremonyName(ceremonyNameArray);

        callbackName(ceremonyNameArray);

        _checkNamesEntered(ceremonyNameArray, dedicatedBy, radioValue);
    };

    const _setDedicatedByValue = (event: any, index: number) => {
        const maxLength = config.charactersLimitForNames ? config.charactersLimitForNames : 31;

        _setDedicatedByArray(event.target.value.substring(0, maxLength - 1), index);
    };

    const _setDedicatedByArray = (name: string, index: number) => {
        const dedicatedByArray = dedicatedBy.slice();

        while (typeof dedicatedByArray[`${index}`] === 'undefined') {
            dedicatedByArray.push('');
        }

        dedicatedByArray[`${index}`] = name;

        dedicatedByArray[`${index}`].trim();

        setDedicatedBy(dedicatedByArray);

        callbackDedicatedBy(dedicatedByArray);

        _checkNamesEntered(ceremonyName, dedicatedByArray, radioValue);
    };

    const _displaySubProductQuantity = (index: number): { value: string; label: string } | null => {
        if (subProductQuantity.length > 0) {
            const selectValueArray = subProductQuantity.slice();

            if (typeof selectValueArray[`${index}`] !== 'undefined' && selectValueArray[`${index}`] !== 0) {
                return (quantity as any)[localeCode as 'en' | 'zh'].quantity.find(
                    (item: { value: string; label: string }) => item.value === String(selectValueArray[`${index}`])
                );
            } else {
                return null;
            }
        }

        return null;
    };

    const _checkNamesEntered = (ceremonyNameArray: string[], dedicatedByArray: string[], categoryArray: string[]) => {
        let namesEntered = true;

        for (let i = 0; i < ceremonyNameArray.length; i++) {
            if (ceremonyNameArray[`${i}`].replace(/;/g, '').trim() === '') {
                namesEntered = false;
                break;
            }

            if (
                categoryArray[`${i}`] === resource.categoryDeceasedLabel[localeCode as 'en' | 'zh'] &&
                dedicatedByArray[`${i}`].trim() === ''
            ) {
                namesEntered = false;
                break;
            }
        }

        callbackNamesEntered(namesEntered);
    };

    const _addItem = () => {
        addRow(1);

        const categoryValueArray = radioValue.slice();
        const ceremonyNameArray = ceremonyName.slice();
        const dedicatedByArray = dedicatedBy.slice();
        const subProductQuantityArray = subProductQuantity.slice();

        categoryValueArray.push(resource.categoryFamilyLabel[localeCode as 'en' | 'zh']);
        ceremonyNameArray.push('');
        dedicatedByArray.push('');
        subProductQuantityArray.push(0);

        setRadioValue(categoryValueArray);
        setCeremonyName(ceremonyNameArray);
        setDedicatedBy(dedicatedByArray);
        setSubProductQuantity(subProductQuantityArray);

        callbackCategory(categoryValueArray);
        callbackName(ceremonyNameArray);
        callbackDedicatedBy(dedicatedByArray);
        callbackSubProductQuantity(subProductQuantityArray);

        _checkNamesEntered(ceremonyNameArray, dedicatedByArray, categoryValueArray);
    };

    const _deleteCartLine = async (index: number): Promise<void> => {
        if (typeof formItems[`${index}`] !== 'undefined') {
            const cartState = await getCartState(actionContext);

            let success = false;

            const cartItems = await getAllBTGPCartLineAsync({ callerContext: actionContext }, cartState.cart.Id);

            if (cartItems.length > 0) {
                const removeCartLinesResult = await cartState.removeCartLines({
                    cartLineIds: [formItems[`${index}`]['cartLineId']]
                });

                if (removeCartLinesResult.status === 'SUCCESS') {
                    success = true;
                }

                const deleteCartLineResult = await deleteBTGPCartLineAsync(
                    { callerContext: actionContext },
                    formItems[`${index}`]['cartLineId']
                );

                if (success && deleteCartLineResult) {
                    deleteRow(index);
                    formItems.splice(index, 1);
                    _updateStateData(index);
                }
            } else {
                deleteRow(index);
                _updateStateData(index);
            }
        } else {
            deleteRow(index);
            _updateStateData(index);
        }
    };

    const _updateStateData = (index: number) => {
        const categoryValueArray = radioValue.slice();
        const ceremonyNameArray = ceremonyName.slice();
        const dedicatedByArray = dedicatedBy.slice();
        const subProductQuantityArray = subProductQuantity.slice();

        if (typeof categoryValueArray[`${index}`] !== 'undefined') {
            if (categoryValueArray.length > 1) {
                categoryValueArray.splice(index, 1);
            } else {
                categoryValueArray[0] = resource.categoryFamilyLabel[localeCode as 'en' | 'zh'];
            }
        }

        if (typeof ceremonyNameArray[`${index}`] !== 'undefined') {
            if (ceremonyNameArray.length > 1) {
                ceremonyNameArray.splice(index, 1);
            } else {
                ceremonyNameArray[0] = '';
            }
        }

        if (typeof dedicatedByArray[`${index}`] !== 'undefined') {
            if (dedicatedByArray.length > 1) {
                dedicatedByArray.splice(index, 1);
            } else {
                dedicatedByArray[0] = '';
            }
        }

        if (typeof subProductQuantityArray[`${index}`] !== 'undefined') {
            if (subProductQuantityArray.length > 1) {
                subProductQuantityArray.splice(index, 1);
            } else {
                subProductQuantityArray[0] = 0;
            }
        }

        setRadioValue(categoryValueArray);
        setCeremonyName(ceremonyNameArray);
        setDedicatedBy(dedicatedByArray);
        setSubProductQuantity(subProductQuantityArray);

        callbackCategory(categoryValueArray);
        callbackName(ceremonyNameArray);
        callbackDedicatedBy(dedicatedByArray);
        callbackSubProductQuantity(subProductQuantityArray);

        _checkNamesEntered(ceremonyNameArray, dedicatedByArray, categoryValueArray);
    };

    useEffect(() => {
        const existingCeremonyName: string[] = [];
        const existingDedicatedBy: string[] = [];
        const existingRadioValue: string[] = [];
        const existingSubProductQuantity: number[] = [0];

        if (formItems.length > 0) {
            for (let i = 0; i < formItems.length; i++) {
                const itemNames: string[] = formItems[`${i}`]['names'];
                const itemDedicatedBy = formItems[`${i}`]['dedicatedBy'];
                const itemCategory = formItems[`${i}`]['category'];
                const itemSubProductQuantity =
                    typeof formItems[`${i}`]['subProductQuantity'] !== 'undefined' ? formItems[`${i}`]['subProductQuantity'] : 0;

                let itemNameCount = 0;

                if (itemCategory === resource.categoryFamilyLabel[localeCode as 'en' | 'zh']) {
                    itemNameCount = noOfNames;
                } else if (itemCategory === resource.categoryCompanyLabel[localeCode as 'en' | 'zh']) {
                    itemNameCount = companyNames;
                } else {
                    itemNameCount = deceasedNames;
                }

                let itemName = '';

                itemNames.map((name, index) => {
                    if (index !== 0 && index < itemNameCount) {
                        itemName += `;${name}`;
                    } else {
                        itemName += name;
                    }
                });

                existingCeremonyName.push(itemName);
                existingDedicatedBy.push(itemDedicatedBy);
                existingRadioValue.push(itemCategory);

                if (i === 0) {
                    existingSubProductQuantity[0] = itemSubProductQuantity;
                } else {
                    existingSubProductQuantity.push(itemSubProductQuantity);
                }
            }

            setCeremonyName(existingCeremonyName);
            setDedicatedBy(existingDedicatedBy);
            setRadioValue(existingRadioValue);
            setSubProductQuantity(existingSubProductQuantity);

            callbackName(existingCeremonyName);
            callbackDedicatedBy(existingDedicatedBy);
            callbackCategory(existingRadioValue);
            callbackSubProductQuantity(existingSubProductQuantity);

            _checkNamesEntered(existingCeremonyName, existingDedicatedBy, existingRadioValue);
        } else {
            callbackCategory(radioValue);
        }
    }, [formItems]);

    const _buildCategoryField = (idx: number): JSX.Element | null => {
        if (typeof radioValue[`${idx}`] === 'undefined') {
            return null;
        }

        return (
            <div className='row'>
                <div className='col-12'>
                    <p className='form-label'>{formLabels.category}</p>
                    <div className='form-field row'>
                        <label className='radio-option col-12 col-lg-3'>
                            <input
                                type='radio'
                                value={resource.categoryFamilyLabel[localeCode as 'en' | 'zh']}
                                checked={radioValue[`${idx}`] === String(resource.categoryFamilyLabel[localeCode as 'en' | 'zh'])}
                                aria-checked={radioValue[`${idx}`] === String(resource.categoryFamilyLabel[localeCode as 'en' | 'zh'])}
                                onChange={event => _onChangeRadioValue(event, idx)}
                            />
                            {resource.categoryFamilyLabel[localeCode as 'en' | 'zh']}
                        </label>

                        <label className='radio-option col-12 col-lg-3'>
                            <input
                                type='radio'
                                value={resource.categoryCompanyLabel[localeCode as 'en' | 'zh']}
                                checked={radioValue[`${idx}`] === String(resource.categoryCompanyLabel[localeCode as 'en' | 'zh'])}
                                aria-checked={radioValue[`${idx}`] === String(resource.categoryCompanyLabel[localeCode as 'en' | 'zh'])}
                                onChange={event => _onChangeRadioValue(event, idx)}
                            />
                            {resource.categoryCompanyLabel[localeCode as 'en' | 'zh']}
                        </label>

                        <label className='radio-option col-12 col-lg-3'>
                            <input
                                type='radio'
                                value={resource.categoryDeceasedLabel[localeCode as 'en' | 'zh']}
                                checked={radioValue[`${idx}`] === String(resource.categoryDeceasedLabel[localeCode as 'en' | 'zh'])}
                                aria-checked={radioValue[`${idx}`] === String(resource.categoryDeceasedLabel[localeCode as 'en' | 'zh'])}
                                onChange={event => _onChangeRadioValue(event, idx)}
                            />
                            {resource.categoryDeceasedLabel[localeCode as 'en' | 'zh']}
                        </label>
                    </div>
                </div>
            </div>
        );
    };

    const _buildNameGroup = (idx: number, noOfNames: number): JSX.Element[] => {
        const nameLabel = formLabels.name;
        const namesArray = Array.apply(null, Array(noOfNames)).map(function(x, i) {
            return i;
        });

        return namesArray.map(nameIndex => {
            return (
                <div key={idx} className='row'>
                    <div className='col-lg-6 form-field'>
                        <p className='form-label'>
                            {nameLabel.endsWith('*')
                                ? nameIndex === 0
                                    ? `${nameLabel.substring(0, nameLabel.length - 1)} ${nameIndex + 1}*`
                                    : nameLabel.replace('*', ` ${nameIndex + 1}`)
                                : `${nameLabel} ${nameIndex}${1}`}
                        </p>
                        <input
                            type='text'
                            inputMode='text'
                            value={_displayName(ceremonyName[`${idx}`], nameIndex)}
                            aria-live='polite'
                            role='spinbutton'
                            onChange={event => _setNameMultipleInputValue(event, idx, nameIndex, noOfNames)}
                            onKeyDown={event => {
                                if (event.keyCode === 13) {
                                    event.preventDefault();
                                }
                            }}
                            className='form-control'
                            maxLength={config.charactersLimitForNames ? config.charactersLimitForNames : 31}
                        />
                    </div>
                </div>
            );
        });
    };

    const _buildSubProductQuantity = (idx: number): JSX.Element | null => {
        return (
            <div className='row'>
                <div className='col-12 form-field'>
                    <hr className='form-sub-hr' />
                    <p className='form-sub-header'>{formLabels.consecration}</p>
                    <p className='form-label'>{formLabels.consecrationSub}</p>
                    <div className='row'>
                        <Select
                            value={_displaySubProductQuantity(idx)}
                            placeholder={formLabels.consecrationPrompt}
                            options={quantity[localeCode as 'en' | 'zh'].quantity}
                            onChange={(event: any) => _setSubProductQuantity(event, idx)}
                            className={'col-lg-6 select'}
                            isSearchable={false}
                        />
                    </div>
                </div>
            </div>
        );
    };

    const _buildDedicatedByField = (idx: number): JSX.Element => {
        return (
            <div className='row'>
                <div className='col-lg-4 form-field'>
                    <p className='form-label'>{formLabels.dedicatedBy}</p>
                    <input
                        type='text'
                        inputMode='text'
                        value={dedicatedBy[`${idx}`]}
                        aria-live='polite'
                        role='spinbutton'
                        onChange={event => _setDedicatedByValue(event, idx)}
                        onKeyDown={event => {
                            if (event.keyCode === 13) {
                                event.preventDefault();
                            }
                        }}
                        className='form-control'
                        maxLength={config.charactersLimitForNames ? config.charactersLimitForNames : 31}
                    />
                </div>
            </div>
        );
    };

    return (
        <div className='frontdesk-purchase-form'>
            <form onSubmit={handleSubmit(onSubmit)} onReset={reset} autoComplete='off'>
                <div className='frontdesk-purchase-form-table'>
                    {rowsData.map((i, idx) => {
                        return (
                            <div key={idx} className='form-record'>
                                <div key={`row${i.id}`} className='form-details row'>
                                    {formScheme.map((element: IField, index: number) => {
                                        if (element.field_name === 'category') {
                                            return (
                                                <div key={index} className='form-details-item col-lg-9'>
                                                    {_buildCategoryField(idx)}
                                                    {radioValue[`${idx}`] ===
                                                        String(resource.categoryFamilyLabel[localeCode as 'en' | 'zh']) &&
                                                        noOfNames > 0 &&
                                                        _buildNameGroup(idx, noOfNames)}
                                                    {radioValue[`${idx}`] ===
                                                        String(resource.categoryCompanyLabel[localeCode as 'en' | 'zh']) &&
                                                        companyNames > 0 &&
                                                        _buildNameGroup(idx, companyNames)}
                                                    {radioValue[`${idx}`] ===
                                                        String(resource.categoryDeceasedLabel[localeCode as 'en' | 'zh']) &&
                                                        deceasedNames > 0 &&
                                                        _buildNameGroup(idx, deceasedNames)}
                                                    {radioValue[`${idx}`] !==
                                                        String(resource.categoryFamilyLabel[localeCode as 'en' | 'zh']) &&
                                                        (deceasedNames > 0 || companyNames > 0) &&
                                                        _buildDedicatedByField(idx)}
                                                    {_buildSubProductQuantity(idx)}
                                                </div>
                                            );
                                        }

                                        if (!isMobile && element.field_type === 'product_price') {
                                            return (
                                                <div key={index} className='form-details-item bordered centred col-2'>
                                                    <p key={index} className='subtotal'>
                                                        $
                                                        {selectedProduct.result?.Price! +
                                                            (subProduct ? subProduct.Price * subProductQuantity[`${idx}`] : 0)}
                                                    </p>
                                                </div>
                                            );
                                        }

                                        if (element.field_type === 'action') {
                                            if (isMobile) {
                                                const style = !isEditMode ? 'form-details-item' : 'form-details-item edit';

                                                return (
                                                    <div key={index} className={style}>
                                                        {!isEditMode && allowMultipleRegistrations && (
                                                            <div className='col-10'>
                                                                <button className='add-row' type='submit' onClick={_addItem}>
                                                                    {resource.addAnotherItemTitle[localeCode as 'en' | 'zh']}
                                                                </button>
                                                            </div>
                                                        )}
                                                        <div className='delete-wrapper col-2'>
                                                            <button className={element.action} onClick={() => _deleteCartLine(idx)} />
                                                        </div>
                                                    </div>
                                                );
                                            }

                                            return (
                                                <div key={index} className='form-details-item centred col-sm-1'>
                                                    <button className={element.action} onClick={() => _deleteCartLine(idx)} />
                                                </div>
                                            );
                                        }

                                        return;
                                    })}
                                </div>
                            </div>
                        );
                    })}
                </div>

                {!isMobile && !isEditMode && allowMultipleRegistrations && (
                    <div className='frontdesk-purchase-form-add'>
                        <button type='submit' onClick={_addItem}>
                            {resource.addAnotherItemTitle[localeCode as 'en' | 'zh']}
                        </button>
                    </div>
                )}
            </form>
        </div>
    );
};

export default ThreeCategoryNamesConsecrationForm1;
